import { render, staticRenderFns } from "./index.vue?vue&type=template&id=411ea4fe&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=411ea4fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411ea4fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411ea4fe')) {
      api.createRecord('411ea4fe', component.options)
    } else {
      api.reload('411ea4fe', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=411ea4fe&scoped=true", function () {
      api.rerender('411ea4fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/attr/index.vue"
export default component.exports